import {} from "@redotech/money/currencies"; // for TS2742
import { CreateShippingRateTableInputSchema } from "@redotech/redo-model/integration/redo-in-shipping/shipping-rate-table";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createShippingMethod = {
  name: "createShippingMethod" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    shippingRateTable: CreateShippingRateTableInputSchema,
  }),
  output: z.null(),
};
export type CreateShippingMethodInput = z.infer<
  typeof createShippingMethod.input
>;
